import React from 'react';
//Import Context 
import staticData from '../../../contexts/staticData.json'
//Import Helpers
import { formatCurrency, formatDate, formatDisplayName } from "../../../shared/helpers";
//Import Icons
import info from '../../../assets/icons/info.svg';
//Import CSS
import './requestHistoryItem.css';

const RequestHistoryItemPayment = ({ historyItem, requestDetails, responseView = false, isPaymentRequest }) => {
    const {
        details,
        sentTo,
        timestamp,
        responsibleName,
        role,
        action,
        responseRequest,
        backups,
        response,
        amountToBePaid,
        paymentAmount
    } = historyItem;

    const {
        attachments
    } = requestDetails;

    const getAllAttachments = () => {
        if (!attachments) return [];

        return Object.values(attachments).flat().map(attachment => ({
            fileName: attachment.fileName,
            fileUrl: attachment.fileUrl
        }));
    };

    const allAttachments = getAllAttachments();

    const responseMapping = {
        approved: 'Aprobado',
        rejected: 'Rechazado',
        observed: 'Observada'
    };

    const AttachmentSection = ({ title, file }) => {
        if (!file || !file.name || !file.url) return null;

        return (
            <li className='document flex'>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                    {file.name}
                </a>
            </li>
        );
    };

    const renderBackups = (backups) => {
        if (!backups || (Array.isArray(backups) && backups.length === 0) ||
            (typeof backups === 'object' && Object.keys(backups).length === 0)) {
            return null;
        }

        // Verifica si es la estructura nueva (con conformityCertificate, invoice, etc.)
        const isNewStructure = backups.hasOwnProperty('conformityCertificate') ||
            backups.hasOwnProperty('invoice') ||
            backups.hasOwnProperty('deliveryGuide') ||
            backups.hasOwnProperty('feeReceipt') ||
            backups.hasOwnProperty('others');

        if (isNewStructure) {

            return (
                <section className="history-item-attachments flex">
                    <p><strong>Documentos adjuntos:</strong></p>
                    <ul className='flex'>
                        {Object.entries(staticData.backupTypes).map(([key, title]) => (
                            backups[key] && (
                                <AttachmentSection
                                    key={key}
                                    title={title}
                                    file={backups[key]}
                                />
                            )
                        ))}
                    </ul>
                </section>
            );
        }

        // Estructura antigua (array de archivos)
        const files = Array.isArray(backups) ? backups :
            Array.isArray(backups.backups) ? backups.backups :
                Array.isArray(backups.officialDocs) ? backups.officialDocs : [];

        return (
            <section className="history-item-attachments flex">
                <p><strong>Documentos adjuntos:</strong></p>
                <ul className='flex'>
                    {files.map((file, index) => (
                        <li key={index} className='document flex'>
                            <a href={file.fileUrl || file.url} target="_blank" rel="noopener noreferrer">
                                {file.fileName || file.name || 'Archivo adjunto'}
                            </a>
                        </li>
                    ))}
                </ul>
            </section>
        );
    };

    const renderActionSpecificContent = () => {
        if (isPaymentRequest) {
            return (
                <>
                    {amountToBePaid && <p><strong>Monto a pagar:</strong> {formatCurrency(amountToBePaid)}</p>}
                    {renderBackups(backups)}
                </>
            );
        } else {
            return (
                <>
                    <p><strong>Respuesta:</strong> {responseMapping[responseRequest] || 'Desconocido'}</p>
                    {renderBackups(backups)}
                </>
            );
        }
    };
    return (
        <>
            <article className={`history-item flex ${responseRequest === 'observed' ? 'response-observed' : responseRequest === 'rejected' ? 'response-rejected' : ''}`}>
                <header className={`history-item-header flex ${responseRequest === 'observed' ? 'response-observed' : responseRequest === 'rejected' ? 'response-rejected' : ''} ${responseView ? 'response' : ''}`}>
                    <span className='span-header flex'>
                        {(responseRequest === 'observed' || responseRequest === 'rejected' || responseView) && (
                            <img
                                src={info}
                                className='icon'
                                alt='icono de solicitud observada'
                            />
                        )}
                        <span>{formatDate(timestamp)} {formatDisplayName(responsibleName)} ({role}) - <strong>{action}</strong></span>
                    </span>
                    {paymentAmount 
                        ? <span><strong>Monto Pago: {formatCurrency((isPaymentRequest && paymentAmount) ? paymentAmount : requestDetails?.amountToBePaid)}</strong></span>
                        : <span><strong>Monto solicitud: {formatCurrency((isPaymentRequest && amountToBePaid) ? amountToBePaid : requestDetails?.amountToBePaid)}</strong></span>
                    }
                </header>
                <section className={`history-item-details flex ${responseView ? 'response' : ''}`}>
                    <p>{details}</p>
                    <p><strong>Enviado a:</strong> {sentTo}</p>
                    {renderActionSpecificContent()}
                </section>
            </article>
            {(response && response.length > 0) && (
                response.map((responseItem, index) => (
                    <RequestHistoryItemPayment
                        key={index}
                        historyItem={responseItem}
                        requestDetails={requestDetails}
                        isPaymentRequest={isPaymentRequest}
                        responseView={true}
                    />
                ))

            )}

        </>
    );
};



export default RequestHistoryItemPayment;